export const useDragManager = (moveItem) => {
  const {
    draggedItemId,
    startItemDrag,
    endBlockDrag,
  } = useBlockDnd();

  const startDrag = (event: DragEvent, item) => {
    event.stopPropagation();
    // Ensure it's the initial dragstart event
    if (event.type === "dragstart") {
      startItemDrag(item.id);
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", item.id);
      }
    }
  };

  const endDrag = () => {
    endBlockDrag();
  };

  const handleMove = (payload) => {
    if (draggedItemId.value && payload.targetId !== draggedItemId.value) {
      moveItem(draggedItemId.value, payload.targetId, payload.index);
    }
    endBlockDrag();
  };

  return {
    startDrag,
    endDrag,
    handleMove,
  };
};
